import React, {useState,  Component, useEffect } from "react";
import ReactDOM from "react-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import NitroButton from '../parts/NitroButton';
import md5 from 'crypto-js/sha256';

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 8;


const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? "rgba(255,255,255,0.2)" : "transparent",
  padding: grid,
});


/**
 * Randomize array sort order using Durstenfeld shuffle
 * @param {array}
 * @return {array}
 */
const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

const stringToIntHash = (str) => {
  let result = 0;
  for (let i = 0; i < str.length; i++) {
    result = result + str.charCodeAt(i);
  }

  return (result % (10 - 0)) + 0;
}


const PrioritySorter = ({ qData, pageStyle, theme, nextStep }) => {
  const [categories, setCategories] = useState(shuffleArray(qData.categories));

  const getItemStyle = (isDragging, draggableStyle, seed) => ({
    userSelect: "none",
    padding: grid * 2,
    borderRadius: 20,
    textAlign: 'center',
    width: (100 - stringToIntHash(md5(seed).toString()))+"%",
    margin: `0 auto ${grid}px auto`,
    color: '#FFFFFF',

    // change background colour if dragging
    background: isDragging ? theme.pageStyle3.hint1 : theme.pageStyle3.hint2,

    // styles we need to apply on draggables
    ...draggableStyle
  });


  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    let tmpCats = reorder(
      categories,
      result.source.index,
      result.destination.index
    );

    setCategories(tmpCats);
  }

  const onSubmit = (data) => {

    const dataToSend = {
      "questionId": qData.id,
      "priorityOrderValue": categories
    }
    nextStep(dataToSend);
  }

  return (
        <>
      <div className="grow py-12">
        <div className="container max-w-lg">

          <p className='text-center text-xs p-3'>{qData.max.text}</p>

            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver)}
                  >
                    {categories.map((item, index) => (
                      <Draggable key={item.id} draggableId={`id-${item.id}`} index={index}>
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            className={`font-black text-xs md:text-base`}
                            style={getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style,
                              item.text
                            )}
                          >
                            {item.text}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>

          <p className='text-center text-xs p-3'>{qData.min.text}</p>

        </div>
      </div>
      <NitroButton label="Next" formIsValid={true} onClick={onSubmit} />
    </>
  );

}

export default PrioritySorter;
